import React from 'react';
import cx from 'classnames';
import '../../../form/CheckBox/index.js';
import '../../../form/CodeInput/index.js';
import '../../../form/CryptoSelect/index.js';
import '../../../form/FileUploader/index.js';
import '../../../form/FormInput/index.js';
import '../../../form/FormSelect/index.js';
import '../../../form/PhoneInput/index.js';
import '../../../form/RadioButton/index.js';
import '../../../form/Select/index.js';
import '../../../form/SelectV2/index.js';
import '../../../form/SelectV3/index.js';
import '../../../form/SelectV4/index.js';
import { SearchInput } from '../../../form/Search/Input/index.js';
import '../../../form/Search/NoResults/index.js';
import '../../../form/Switch/index.js';
import '../../../form/DatePickerInput/index.js';
import { CryptoStatistic } from '../CryptoStatistic/index.js';
import styles from './index.module.scss.js';

const CryptoStatisticList = ({
  list,
  onSearchChange,
  onSubmit,
  searchString,
  withSearch = true,
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement("div", { style, className: cx(styles.box, className), ...props }, withSearch && /* @__PURE__ */ React.createElement(
  SearchInput,
  {
    className: styles.search,
    inputTheme: "blue",
    onSubmit,
    value: searchString,
    placeholder: "Search",
    onChange: (event) => {
      if (event.target) {
        onSearchChange(event.target.value);
      } else {
        onSearchChange(event);
      }
    }
  }
), /* @__PURE__ */ React.createElement("div", { className: styles.list }, list.map((item) => /* @__PURE__ */ React.createElement(CryptoStatistic, { className: styles.crypto, ...item }))));
CryptoStatisticList.displayName = "CryptoStatisticList";

export { CryptoStatisticList };
//# sourceMappingURL=index.js.map
